<app-error-card
  title="Page not found!"
  subheader="Sorry for the inconvenience"
  feedbackLabel="Report Issue"
  [messageHtml]="randomFact()"
>
</app-error-card>
